import { Component, OnInit, AfterContentChecked, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { SchoolProgramPlacementDetails } from '../models/school-program-placement-details';
import { SchoolSubject, School, Term, LookupData, SchoolDuration, Tab_Title, SchoolCalendarTermDTO } from 'src/app/shared/models/lookup-data.model';
import { ErrorResponse, ErrorKeyValuePair } from 'src/app/shared/models/error.model';
import { Store } from '@ngrx/store';
import { DateTime } from 'luxon';
import { Action_ApplicationSectionSaved, Action_ApplicationProgramChanged } from '../state/actions';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Observable, merge, Subscription } from 'rxjs';
import { compareSchoolProgramPlacementDetails } from '../shared/utils/ModelUtils';
import { slideInOut } from '../animations/slideInOut';
import { FormService } from 'src/app/shared/services/form.service';
import { UserInfo } from 'src/app/shared/models/user.model';
import { AgencyContractService } from 'src/app/shared/services/agency-contract.service';
import { Title } from '@angular/platform-browser';
import { debounceTime, tap } from 'rxjs/operators';
import { LookupService } from 'src/app/shared/services/lookup.service';
import * as moment from 'moment';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'online-app-school-program-placement',
  templateUrl: './school-program-placement.component.html',
  styleUrls: ['./school-program-placement.component.scss'],
  host: {
    class: 'application-section-component'
  },
  animations: [slideInOut]
})
export class SchoolProgramPlacementComponent implements OnInit, AfterContentChecked, OnDestroy {

  schoolProgramFormGroup: FormGroup;
  applicationId: number;
  wishToEnrolIec: boolean = false;
  hasASiblingEnrollingAtTheSameTime: boolean;
  isSiblingEnrolledInAustralia: boolean;
  isEligibleForStudyAbroad: boolean;
  isIntensiveEnglishCourseAvailable: boolean;
  studentAge: number;
  isStudentFromRegularCountry: boolean;
  isFormSubmitted: boolean;
  schoolSubjects: SchoolSubject[];
  schoolSubjects2: SchoolSubject[];
  schoolSubjects3: SchoolSubject[];
  schoolSubjects4: SchoolSubject[];
  schoolSubjects5: SchoolSubject[];
  schoolSubjects6: SchoolSubject[];
  schoolSubjects7: SchoolSubject[];

  year12InNSW: boolean;
  year11InNSW: boolean;
  fromTRP: boolean;


  schools: School[];
  originalSchoolList: School[];

  availableSchoolSubjects: SchoolSubject[];
  terms: Term[];
  durations: SchoolDuration[];
  isSaveSuccessful = false;
  isScrollDone = false;
  availableIecStartYear: LookupData[];
  availableProgramStartYear: LookupData[];
  isSubmittedApplication = false;
  showChangeImpactModal: boolean = false;

  selectedProgram = '';
  selectedYearOfEntryCode = '';
  selectedWishToEnrolIec: boolean = false;
  selectedIecStartTermCode = '';
  selectedStartTermCode = '';
  selectedDuration: LookupData;
  selectedCompulsorySubject1: LookupData;
  selectedCompulsorySubject2: LookupData;
  selectedCompulsorySubject3: LookupData;
  selectedCompulsorySubject4: LookupData;
  selectedCompulsorySubject5: LookupData;
  selectedCompulsorySubject6: LookupData;
  selectedCompulsorySubject7: LookupData;
  selectedPreferredSchool1: LookupData;
  selectedPreferredSchool2: LookupData;
  selectedPreferredSchool3: LookupData;
  selectedHasASiblingEnrollingAtTheSameTime: boolean;
  selectedIsSiblingEnrolledInAustralia: boolean;

  selectedYear12InNSW: boolean;
  selectedYear11InNSW: boolean;
  selectedFromTRP: boolean;

  selectedIecStartYear: LookupData;
  selectedProgramStartYear: LookupData;

  matchingPreferredSchools1: School[] = [];
  selectedPreferredSchool1Name = '';
  matchingPreferredSchools2: School[] = [];
  selectedPreferredSchool2Name = '';
  matchingPreferredSchools3: School[] = [];
  selectedPreferredSchool3Name = '';

  matchingSiblingSchools: School[] = [];

  initialSchoolProgramPlacementDetails: SchoolProgramPlacementDetails;

  eligibleYearOfEntries: string[] = [];

  checkAdditionMsg: boolean;

  errorKeyFormFieldMapping = [
    { apiErrorKeyName: 'SchoolProgramType', formFieldName: 'schoolProgramType', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'YearOfEntryCode', formFieldName: 'yearOfEntryCode', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'WishToEnrolIec', formFieldName: 'wishToEnrolIec', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'IecStartTermCode', formFieldName: 'iecStartTermCode', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'IecStartTermYear', formFieldName: 'iecStartTermYear', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'IecDurationCode', formFieldName: 'iecDurationCode', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'StartTermCode', formFieldName: 'startTermCode', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'StartTermYear', formFieldName: 'startTermYear', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'DurationCode', formFieldName: 'durationCode', apiValidationErrorMsg: null },

    { apiErrorKeyName: 'Year12InNSW', formFieldName: 'year12InNSW', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Year11InNSW', formFieldName: 'year11InNSW', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'FromTRP', formFieldName: 'fromTRP', apiValidationErrorMsg: null },

    { apiErrorKeyName: 'CompulsorySubject1Code', formFieldName: 'compulsorySubject1Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CompulsorySubject2Code', formFieldName: 'compulsorySubject2Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CompulsorySubject2Code', formFieldName: 'compulsorySubject2Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CompulsorySubject3Code', formFieldName: 'compulsorySubject3Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CompulsorySubject4Code', formFieldName: 'compulsorySubject4Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CompulsorySubject5Code', formFieldName: 'compulsorySubject5Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CompulsorySubject6Code', formFieldName: 'compulsorySubject6Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CompulsorySubject7Code', formFieldName: 'compulsorySubject7Code', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'PreferredSchool1Id', formFieldName: 'preferredSchool1Id', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'PreferredSchool2Id', formFieldName: 'preferredSchool2Id', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'PreferredSchool3Id', formFieldName: 'preferredSchool3Id', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'HasASiblingEnrollingAtTheSameTime', formFieldName: 'hasASiblingEnrollingAtTheSameTime', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'IsSiblingEnrolledInAustralia', formFieldName: 'isSiblingEnrolledInAustralia', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SiblingGivenName', formFieldName: 'siblingGivenName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SiblingFamilyName', formFieldName: 'siblingFamilyName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SiblingPreferredName', formFieldName: 'siblingPreferredName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SiblingDateOfBirth', formFieldName: 'siblingDateOfBirth', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SiblingSchoolName', formFieldName: 'siblingSchoolName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SiblingStudentNumber', formFieldName: 'siblingStudentNumber', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SiblingComments', formFieldName: 'siblingComments', apiValidationErrorMsg: null }
  ];

  private hasTakenEnglishTest: boolean;
  private areAllSubjectsTaughtInEnglish: boolean;
  private isEnlishNativeLanguage: boolean;
  private userInfo: UserInfo;

  private subscriptionsToDispose: Subscription[] = [];

  agentHasValidIspContract: boolean = true;
  agentHasValidStudyAbroadContract: boolean = true;

  isStudentCurrentlyEnrolledInAustralia: boolean = false;
  schoolCalendarTermsForValidation: SchoolCalendarTermDTO[] = [];

  initSchoolProgramDetailsFromApiResponse: SchoolProgramPlacementDetails;

  private constrTime = Date.now();

  @ViewChild('resolve') resolve: ElementRef;

  constructor(fb: FormBuilder,
    private agencyContractService: AgencyContractService,
    private router: Router,
    private store: Store<any>,
    private modalService: ModalService,
    private formService: FormService,
    private activatedRoute: ActivatedRoute,
    private applicationService: ApplicationService,
    private lookupService: LookupService,
    private utilityService: UtilityService,
    private titleService: Title) {

    // this.configureJquery();

    this.activatedRoute.parent.params.subscribe(params => {
      this.applicationId = +params['id'];
    });

    this.schoolProgramFormGroup = fb.group({
      schoolProgramType: '',
      yearOfEntryCode: '',
      wishToEnrolIec: '',
      iecStartTermCode: '',
      iecStartTermYear: '',
      iecDurationCode: '',
      startTermCode: '',
      startTermYear: '',
      durationCode: '',
      year12InNSW: '',
      year11InNSW: '',
      fromTRP:'',
      compulsorySubject1Code: [{ value: 'English', disabled: true }],
      compulsorySubject2Code: '',
      compulsorySubject3Code: '',
      compulsorySubject4Code: '',
      compulsorySubject5Code: '',
      compulsorySubject6Code: '',
      compulsorySubject7Code: '',
      preferredSchool1Id: '',
      preferredSchool2Id: '',
      preferredSchool3Id: '',
      hasASiblingEnrollingAtTheSameTime: '',
      isSiblingEnrolledInAustralia: '',
      siblingGivenName: '',
      siblingFamilyName: '',
      siblingPreferredName: '',
      siblingDateOfBirth: null,
      siblingSchoolName: '',
      siblingStudentNumber: '',
      siblingComments: '',
      isEligibleForStudyAbroad: '',
      ageInYears: ''
    });

    console.log(`school program constructor: ${this.constrTime}`);
    console.log(`school program constructor ended: ${Date.now()}: Time elapsed: ${(Date.now() - this.constrTime).toString()}ms`);
  }

  ngOnInit() {
    setTimeout(() => {
      const sT = Date.now();
      console.log(`school program : init start - ${sT}`);

      if(localStorage.getItem("isAgent") == "true"){
        this.titleService.setTitle(Tab_Title.Agent_SchoolProgramAndPlacements_Title);
      }else{
        this.titleService.setTitle(Tab_Title.SchoolProgramAndPlacements_Title);
      }
      this.userInfo = this.activatedRoute.parent.parent.snapshot.data['currentUser'] as UserInfo;
      this.schoolSubjects = this.activatedRoute.snapshot.data['schoolSubjects'];
      this.schools = this.activatedRoute.snapshot.data['schools'];
      this.originalSchoolList = this.schools;
      // Todo filter more by SchoolSubType
      this.schools = this.schools.filter(x => x.SchoolSubType.Description !== 'Intensive English Centre' );

      //console.log("--- All ISP and SA schools from Referecen cache API is:", this.schools);

      this.terms = this.activatedRoute.snapshot.data['terms'];
      this.durations = this.activatedRoute.snapshot.data['durations'];
      //console.log("Durations data is ==>", this.durations);

      this.isIntensiveEnglishCourseAvailable = false;

      const subjectsExcludingEnglish = this.schoolSubjects.filter(s => s.Code !== 'English');
      this.schoolSubjects2 = [...subjectsExcludingEnglish];
      this.schoolSubjects3 = [...subjectsExcludingEnglish];
      this.schoolSubjects4 = [...subjectsExcludingEnglish];
      this.schoolSubjects5 = [...subjectsExcludingEnglish];
      this.schoolSubjects6 = [...subjectsExcludingEnglish];
      this.schoolSubjects7 = [...subjectsExcludingEnglish];

      this.subscriptionsToDispose.push(
        merge(
          this.schoolProgramFormGroup.get('compulsorySubject2Code').valueChanges
            .pipe(debounceTime(250)),
          this.schoolProgramFormGroup.get('compulsorySubject3Code').valueChanges
            .pipe(debounceTime(250)),
          this.schoolProgramFormGroup.get('compulsorySubject4Code').valueChanges
            .pipe(debounceTime(250)),
          this.schoolProgramFormGroup.get('compulsorySubject5Code').valueChanges
            .pipe(debounceTime(250)),
          this.schoolProgramFormGroup.get('compulsorySubject6Code').valueChanges
            .pipe(debounceTime(250)),
          this.schoolProgramFormGroup.get('compulsorySubject7Code').valueChanges
            .pipe(debounceTime(250)),
        ).subscribe(() => this.massUpdateSubjectOptions())
      );

      const dropdownDefault = {
        Code: '',
        Description: 'Please select'
      };

      if (!this.durations.some(d => d.Description === 'Please select')) {
        this.durations.unshift(dropdownDefault);
      }

      this.subscriptionsToDispose.push(
        this.schoolProgramFormGroup.get("startTermCode").valueChanges
        .pipe(debounceTime(250))
        .subscribe(newValue => {
          this.onStartTermChanged(newValue);
        })
      );

      console.log(`school program : init until the ajax calls. Time elapsed: ${(Date.now() - sT).toString()}ms`);

      this.applicationService.getSchoolProgramAndPlacementPackage(this.applicationId)
        .subscribe((data: SingleResultApiResponse) => {
          console.log(`school program : getApplicationDetails, getStudentDetails, getSchoolProgramPlacementDetails. Time elapsed: ${(Date.now() - sT).toString()}ms`);
          const programPackage = data.Result;
          const applicationDetails = programPackage.ApplicationDetails;
          const studentDetails = programPackage.StudentDetails;
          const schoolProgramPlacementDetails = programPackage.SchoolProgram;
          const englishProficiency = programPackage.EnglishProficiency;

          this.hasTakenEnglishTest = englishProficiency && englishProficiency.HasTakenTest;
          this.areAllSubjectsTaughtInEnglish = englishProficiency && englishProficiency.AllSubjectsTaughtInEnglish;
          this.isEnlishNativeLanguage = englishProficiency && englishProficiency.SpeaksEnglishAtHome;
          this.checkAdditionMsg = schoolProgramPlacementDetails.AllowAdditionalMessage;
          this.isSubmittedApplication = applicationDetails.ApplicationStatus === 'Submitted';

          this.isStudentCurrentlyEnrolledInAustralia = studentDetails.IsStudentAlreadyEnrolledInAustralia;

          // If the application has already been submitted, ignore the contract validity
          this.agentHasValidIspContract = this.isSubmittedApplication || this.agencyContractService.doesAgencyHaveValidIspContractForNationality(this.userInfo, studentDetails.CountryOfNationalityId);
          this.agentHasValidStudyAbroadContract = this.isSubmittedApplication || this.agencyContractService.doesAgencyHaveValidStudyAbroadContractForNationality(this.userInfo, studentDetails.CountryOfNationalityId);

          // Renu:- we beed the school calendar data to validate start term and start year as per new business rules (MN-6124)
          // Only really required when the application isn't already submitted
          if (!this.isSubmittedApplication) {
            var today = new Date();
            this.lookupService.getSchoolCalendarTermsBetween(new Date(`${today.getFullYear()}-01-01`), new Date(`${today.getFullYear() + 3}-12-31`))
              .pipe(
                tap(data => this.schoolCalendarTermsForValidation = data)
              ).subscribe();
          }

          this.initSchoolProgramDetailsFromApiResponse = schoolProgramPlacementDetails as SchoolProgramPlacementDetails

          this.updateFormValuesFromProgramDetails(schoolProgramPlacementDetails);
          // this.configureJquery();
          this.initialSchoolProgramPlacementDetails = this.getSchoolProgramPlacementDetails();

          if (this.isSubmittedApplication) {
            this.schoolProgramFormGroup.disable();
          }

          if (!this.agentHasValidIspContract && this.initialSchoolProgramPlacementDetails.SchoolProgramType === 'International') {
            // reset selection and update section status to incomplete
            this.updateProgram('');
            // may need to set the section staus to incomplete
          }

          if (!this.agentHasValidStudyAbroadContract && this.initialSchoolProgramPlacementDetails.SchoolProgramType === 'StudyAbroad') {
            // reset selection and update section status to incomplete
            this.updateProgram('');
            // may need to set the section staus to incomplete
          }

        });
    }, 4);
  }

  ngOnDestroy() {
    this.subscriptionsToDispose.forEach(s => s.unsubscribe());
  }

  private massUpdateSubjectOptions() {
    const selectedSchoolSubject2 = this.schoolProgramFormGroup.get('compulsorySubject2Code').value;
    const selectedSchoolSubject3 = this.schoolProgramFormGroup.get('compulsorySubject3Code').value;
    const selectedSchoolSubject4 = this.schoolProgramFormGroup.get('compulsorySubject4Code').value;
    const selectedSchoolSubject5 = this.schoolProgramFormGroup.get('compulsorySubject5Code').value;
    const selectedSchoolSubject6 = this.schoolProgramFormGroup.get('compulsorySubject6Code').value;
    const selectedSchoolSubject7 = this.schoolProgramFormGroup.get('compulsorySubject7Code').value;

    this.updateSubjectOptionsForSubjectNumber(2, [selectedSchoolSubject3, selectedSchoolSubject4, selectedSchoolSubject5,
      selectedSchoolSubject6, selectedSchoolSubject7]);
    this.updateSubjectOptionsForSubjectNumber(3, [selectedSchoolSubject2, selectedSchoolSubject4, selectedSchoolSubject5,
      selectedSchoolSubject6, selectedSchoolSubject7]);
    this.updateSubjectOptionsForSubjectNumber(4, [selectedSchoolSubject2, selectedSchoolSubject3, selectedSchoolSubject5,
      selectedSchoolSubject6, selectedSchoolSubject7]);
    this.updateSubjectOptionsForSubjectNumber(5, [selectedSchoolSubject2, selectedSchoolSubject3, selectedSchoolSubject4,
      selectedSchoolSubject6, selectedSchoolSubject7]);
    this.updateSubjectOptionsForSubjectNumber(6, [selectedSchoolSubject2, selectedSchoolSubject3, selectedSchoolSubject4,
      selectedSchoolSubject5, selectedSchoolSubject7]);
    this.updateSubjectOptionsForSubjectNumber(7, [selectedSchoolSubject2, selectedSchoolSubject3, selectedSchoolSubject4,
      selectedSchoolSubject5, selectedSchoolSubject6]);
  }

  onStartTermChanged(value) {
    this.availableProgramStartYear = [{
      Code: '',
      Description: 'Please select'
    }];

    if (value) {

      if (this.isSubmittedApplication) {
        this.availableProgramStartYear.push({
          Description: this.initSchoolProgramDetailsFromApiResponse.StartTermYear.toString(),
          Code: this.initSchoolProgramDetailsFromApiResponse.StartTermYear.toString()
        });
        return;
      }

      const startTerm = Number(value.replace('Term', ''));
      const today = new Date();
      const currentYear = today.getFullYear();

      today.setHours(0, 0, 0, 0);

      let i = currentYear;

      while (i <= currentYear + 3) {
        let termIter = this.schoolCalendarTermsForValidation.find(x => x.Year === i && x.TermNumber === startTerm);
        // default fall back, in case the school calendar service falls apart on us
        if (!termIter) {
          termIter = {
            Year: i,
            TermNumber: startTerm,
            Weeks: 10,
            StartDate: new Date(i, startTerm * 3 - 3),
            EndDate: new Date(i, startTerm * 3, 0)
          };
        }

        let startYearPossibleInIter = false;

        if (this.isStudentCurrentlyEnrolledInAustralia) {
          startYearPossibleInIter = moment(termIter.EndDate).toDate() > today && moment(termIter.StartDate).diff(today, 'months', true) <= 18;
        } else {
          let cutoffDateToApply = moment(termIter.StartDate).add(-1 * (startTerm === 1 ? 12 : 9) * 7, 'days');
          cutoffDateToApply = cutoffDateToApply.add(-cutoffDateToApply.get('day'), 'days').add(5, 'days');
          startYearPossibleInIter = today <= cutoffDateToApply.toDate();
          startYearPossibleInIter = startYearPossibleInIter && moment(termIter.StartDate).diff(today, 'months', true) <= 18;
        }

        if (startYearPossibleInIter) {
            this.availableProgramStartYear.push({
              Description: i.toString(),
              Code: i.toString()
            });
        }
        i++;
      }

      if (this.schoolProgramFormGroup.controls.startTermYear.value
        && !this.availableProgramStartYear.find(x => x.Code === this.schoolProgramFormGroup.controls.startTermYear.value.toString())) {
        this.schoolProgramFormGroup.controls.startTermYear.setValue(null);
        this.schoolProgramFormGroup.controls.startTermYear.markAsUntouched();
      }
    }
  }

  private monthDiff(dateFrom: Date, dateTo: Date): number {
    return dateTo.getMonth() - dateFrom.getMonth() +
      (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
  }



  updateSubjectOptionsForSubjectNumber(subjectNumber: number, selectedOtherSubjects: string[]) {
    const subjectsAfterExclusion = this.schoolSubjects.filter(s => selectedOtherSubjects.indexOf(s.Code) === -1);

    switch(subjectNumber) {
      case 2:
        this.schoolSubjects2 = [...subjectsAfterExclusion];
        break;
      case 3:
        this.schoolSubjects3 = [...subjectsAfterExclusion];
        break;
      case 4:
        this.schoolSubjects4 = [...subjectsAfterExclusion];
        break;
      case 5:
        this.schoolSubjects5 = [...subjectsAfterExclusion];
        break;
      case 6:
        this.schoolSubjects6 = [...subjectsAfterExclusion];
        break;
      case 7:
        this.schoolSubjects7 = [...subjectsAfterExclusion];
        break;
    }
  }

  getDateInString(dateObject: Date): string {
    return `${dateObject.getDate()}/${dateObject.getMonth() + 1}/${dateObject.getFullYear()}`;
  }

  setSiblingDateOfBirth(dateObject: Date) {
    this.schoolProgramFormGroup.patchValue({
      siblingDateOfBirth: dateObject,
    });
    this.schoolProgramFormGroup.updateValueAndValidity();
  }

  updateProgram(program: string) {
    this.selectedProgram = program;

    this.schoolProgramFormGroup.patchValue({
      schoolProgramType: program
    });

    //console.log("current program type is:", program);

    if (program.toLocaleLowerCase() === "international") {
      // this.schools = this.schools.filter(s => s.HasISP); //this should have Gender filter applied already
      this.schoolProgramFormGroup.get('durationCode').setValue("");
    }
    else {
      // this.schools = this.schools.filter(s => s.HasStudyAbroad); //this should have Gender filter applied already
      //StudyAborad: default Duration shown as '2 Terms'
      this.schoolProgramFormGroup.get('durationCode').setValue("2Term");
    }

    //console.log("~~School list after ProgramType filter is:", this.schools);

    this.schoolProgramFormGroup.updateValueAndValidity();

  }

  isAnyPrimaryYearsEnabled(): boolean {
    const isPrimaryEnabled = !this.isKinderGardenDisabled() || !this.isYear1Disabled() || !this.isYear2Disabled() ||
      !this.isYear3Disabled() || !this.isYear4Disabled() || !this.isYear5Disabled() || !this.isYear6Disabled();
    return isPrimaryEnabled;
  }

  isKinderGardenDisabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Kindergarten');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear1Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year1');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear2Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year2');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear3Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year3');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear4Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year4');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear5Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year5');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear6Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year6');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear7Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year7');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear8Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year8');
    return !isEligibleYear || this.selectedProgram === 'StudyAbroad';
  }

  isYear9Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year9');
    return !isEligibleYear;
  }

  isYear10Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year10');
    return !isEligibleYear;
  }

  isYear11Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year11');
    return !isEligibleYear;
  }

  isYear12Disabled(): boolean {
    const isEligibleYear = this.eligibleYearOfEntries.some(yearOfEntry => yearOfEntry === 'Year12');
    return !isEligibleYear;
  }

  isTerm3Term4Disabled(): boolean {
    return (this.selectedYearOfEntryCode==='Year12' && !(this.selectedYear11InNSW === true || this.selectedYear12InNSW === true || this.selectedFromTRP === true));
  }

  showYear12ErrorMsg(): boolean {
    return (this.selectedYearOfEntryCode==='Year12' && !(this.selectedYear11InNSW === true || this.selectedYear12InNSW === true || this.selectedFromTRP === true));
  }


  //Renu:- MN-6123 - We would like students of all nationalities to be able to apply for primary school
  isRegularCountryGradeError(): boolean {
    return false; // this.isStudentFromRegularCountry && (this.isYearOfEntryLesserThan4() || this.isFirstSemesterYear4());
  }

  isYearOfEntryLesserThan4(): boolean {
    return this.selectedYearOfEntryCode === 'Kindergarten'
      || this.selectedYearOfEntryCode === 'Year1'
      || this.selectedYearOfEntryCode === 'Year2'
      || this.selectedYearOfEntryCode === 'Year3';
  }

  isFirstSemesterYear4(): boolean {
    return this.selectedYearOfEntryCode === 'Year4' &&
      (this.selectedStartTermCode === 'Term1' || this.selectedStartTermCode === 'Term2');
  }

  isPrimaryYear() {
    return this.selectedYearOfEntryCode === 'Kindergarten'
      || this.selectedYearOfEntryCode === 'Year1'
      || this.selectedYearOfEntryCode === 'Year2'
      || this.selectedYearOfEntryCode === 'Year3'
      || this.selectedYearOfEntryCode === 'Year4'
      || this.selectedYearOfEntryCode === 'Year5'
      || this.selectedYearOfEntryCode === 'Year6';
  }

  isLastTwoYear() {
    return this.selectedYearOfEntryCode === 'Year11'
      || this.selectedYearOfEntryCode === 'Year12';
  }

  getProgramSubText(): string {
    return this.isPrimaryYear() ? '1 of 4' : '1 of 5';
  }

  getStartTermSubText(): string {
    return this.isPrimaryYear() ? '2 of 4' : '2 of 5';
  }

  getSchoolSelectionSubText(): string {
    return this.isPrimaryYear() ? '3 of 4' : '4 of 5';
  }

  getSiblingInformationSelectionSubText(): string {
    return this.isPrimaryYear() ? '4 of 4' : '5 of 5';
  }

  updateyearOfEntryCode(yearOfEntryCode: string) {
    this.selectedYearOfEntryCode = yearOfEntryCode;

    this.schoolProgramFormGroup.patchValue({
      yearOfEntryCode: yearOfEntryCode
    });

    if (yearOfEntryCode === 'Year7' ||
      yearOfEntryCode === 'Year8' ||
      yearOfEntryCode === 'Year9' ||
      yearOfEntryCode === 'Year10' ||
      yearOfEntryCode === 'Year11' ||
      yearOfEntryCode === 'Year12') {
      this.isIntensiveEnglishCourseAvailable = true;
    } else {
      this.isIntensiveEnglishCourseAvailable = false;
    }

    this.schoolProgramFormGroup.updateValueAndValidity();

  }



  onSchool1Search(schoolName: string) {
    this.matchingPreferredSchools1 = this.getMatchingPreferredSchools(schoolName, 1);
    this.selectedPreferredSchool1Name = schoolName;

    if (this.matchingPreferredSchools1.length === 0) {
      //not found or user clears other prefer-school field or copy/paste existing school
      //this.updateSelectableSchoolList();
    }
  }

  onSchool2Search(schoolName: string) {
    this.matchingPreferredSchools2 = this.getMatchingPreferredSchools(schoolName, 2);
    this.selectedPreferredSchool2Name = schoolName;

    if (this.matchingPreferredSchools2.length === 0) {
      //not found or user clears other prefer-school field or copy/paste existing school
      //this.updateSelectableSchoolList();
    }
  }

  onSchool3Search(schoolName: string) {
    this.matchingPreferredSchools3 = this.getMatchingPreferredSchools(schoolName, 3);
    this.selectedPreferredSchool3Name = schoolName;

    if (this.matchingPreferredSchools3.length === 0) {
      //not found or user clears other prefer-school field or copy/paste existing school
      //this.updateSelectableSchoolList();
    }
  }


  onSiblingSchoolSearch(schoolName: string) {
    // Who did this???
    // this.matchingSiblingSchools = this.getMatchingPreferredSchools(schoolName);
    schoolName = schoolName.trim();
    if (schoolName) {
      this.matchingSiblingSchools = this.originalSchoolList.filter(
        x => x.Name.toLowerCase().startsWith(schoolName.toLowerCase()));
    } else {
      this.matchingSiblingSchools = [];
    }
  }

  getMatchingPreferredSchools(schoolName: string, index: number) {
    let matchingPreferredSchools: School[] = [];
    schoolName = schoolName.trim();
    if (schoolName) {
      matchingPreferredSchools = this.schools.filter(school => school.Name.toLowerCase().startsWith(schoolName.toLowerCase()))
      const program = this.selectedProgram;
      if (!program) {
        return [];
      }
      if (program.toLocaleLowerCase() === 'international') {
        matchingPreferredSchools = matchingPreferredSchools.filter(x => x.HasISP);
      } else {
        matchingPreferredSchools = matchingPreferredSchools.filter(x => x.HasStudyAbroad);
      }
      if (this.isPrimaryYear()) {
        matchingPreferredSchools = matchingPreferredSchools.filter(x => x.SchoolLevel.Description === 'Primary School');
      } else {
        matchingPreferredSchools = matchingPreferredSchools.filter(x => x.SchoolLevel.Description === 'Secondary School');
      }
      if (index === 1) {
        matchingPreferredSchools = matchingPreferredSchools.filter(
          x => x.Name !== this.selectedPreferredSchool2Name && x.Name !== this.selectedPreferredSchool3Name);
      }
      if (index === 2) {
        matchingPreferredSchools = matchingPreferredSchools.filter(
          x => x.Name !== this.selectedPreferredSchool1Name && x.Name !== this.selectedPreferredSchool3Name);
      }
      if (index === 3) {
        matchingPreferredSchools = matchingPreferredSchools.filter(
          x => x.Name !== this.selectedPreferredSchool1Name && x.Name !== this.selectedPreferredSchool2Name);
      }
    } else {
      matchingPreferredSchools = [];
    }
    return matchingPreferredSchools;
  }

  updatePreferredSchoolByName(schoolName: string, schoolIndex: number) {
    const selectedSchool = this.originalSchoolList.find(school => school.Name === schoolName);

    //console.log(`schoolIndex:${schoolIndex},selectedSchool.SchoolId:${selectedSchool ? selectedSchool.Id : ''}`);

    switch (schoolIndex) {
      case 1:
        this.selectedPreferredSchool1Name = selectedSchool ? selectedSchool.Name : '';
        this.schoolProgramFormGroup.patchValue({
          preferredSchool1Id: selectedSchool ? selectedSchool.Id : ''
        });
        break;
      case 2:
        this.selectedPreferredSchool2Name = selectedSchool ? selectedSchool.Name : '';
        this.schoolProgramFormGroup.patchValue({
          preferredSchool2Id: selectedSchool ? selectedSchool.Id : ''
        });
        break;
      case 3:
        this.selectedPreferredSchool3Name = selectedSchool ? selectedSchool.Name : '';
        this.schoolProgramFormGroup.patchValue({
          preferredSchool3Id: selectedSchool ? selectedSchool.Id : ''
        });
        break;
    }

    this.schoolProgramFormGroup.updateValueAndValidity();


    //also temporarily remove that school fromSchoolList
    //this.updateSelectableSchoolList();
  }

  selectSiblingSchool(school: School) {
    this.schoolProgramFormGroup.patchValue({
      siblingSchoolName: school.Name
    });
    this.matchingSiblingSchools = [];

    this.schoolProgramFormGroup.updateValueAndValidity();
  }

  isValidIecValues(): boolean {

    const iecStartTerm = this.schoolProgramFormGroup.get('iecStartTermCode').value;
    const iecStartTermYear = this.schoolProgramFormGroup.get('iecStartTermYear').value;

    let validIecStartTerm = false;
    let validIecStartYear = false;

    if (iecStartTerm === 'Term1' ||
      iecStartTerm === 'Term2' ||
      iecStartTerm === 'Term3' ||
      iecStartTerm === 'Term4') {
      validIecStartTerm = true;
    }

    if (iecStartTermYear >= 2018 && iecStartTermYear < 2050) {
      validIecStartYear = true;
    }

    return validIecStartTerm && validIecStartYear;

  }

  updateSchoolStartTermYear() {

    if (this.isValidIecValues()) {

      const iecStartTerm = this.schoolProgramFormGroup.get('iecStartTermCode').value;
      const iecStartTermYear = this.schoolProgramFormGroup.get('iecStartTermYear').value;

      let schoolStartYear = iecStartTermYear;

      if (iecStartTerm === 'Term1') {
        this.selectedStartTermCode = 'Term3';
      } else if (iecStartTerm === 'Term2') {
        this.selectedStartTermCode = 'Term4';
      } else if (iecStartTerm === 'Term3') {
        this.selectedStartTermCode = 'Term1';
      } else if (iecStartTerm === 'Term4') {
        this.selectedStartTermCode = 'Term2';
      }

      if (iecStartTerm === 'Term3' || iecStartTerm === 'Term4') {
        schoolStartYear = Number(schoolStartYear) + 1;
      }

      this.schoolProgramFormGroup.patchValue({
        startTermCode: this.selectedStartTermCode,
        startTermYear: schoolStartYear,
      });

      this.schoolProgramFormGroup.updateValueAndValidity();

    } else {

      this.schoolProgramFormGroup.patchValue({
        startTermCode: '',
        startTermYear: '',
      });

      this.schoolProgramFormGroup.updateValueAndValidity();

    }



  }

  updateWishToEnrolIec(wishToEnrolIec: boolean) {
    this.selectedWishToEnrolIec = wishToEnrolIec && false;


    this.schoolProgramFormGroup.patchValue({
      wishToEnrolIec: wishToEnrolIec && false
    });

    if (!wishToEnrolIec) {
      this.schoolProgramFormGroup.patchValue({
        iecStartTermCode: '',
        iecStartTermYear: '',
      });
    }

    this.schoolProgramFormGroup.updateValueAndValidity();
  }

  getSchoolStartTermText(): string {

    const startTerm = this.schoolProgramFormGroup.get('startTermCode').value;

    let startTermText = '';

    if (startTerm === 'Term1') {
      startTermText = 'Term 1 January';
    } else if (startTerm === 'Term2') {
      startTermText = 'Term 2 April';
    } else if (startTerm === 'Term3') {
      startTermText = 'Term 3 July';
    } else if (startTerm === 'Term4') {
      startTermText = 'Term 4 October';
    } else {
      startTermText = '<Please select IEC Start Term and Year>';
    }

    return startTermText;
  }

  getIECTuitionAdviceText(): string {
    let iecText: string = '';
    if (this.selectedYearOfEntryCode && !this.isPrimaryYear()) {
      // if (this.hasTakenEnglishTest || this.areAllSubjectsTaughtInEnglish || this.isEnlishNativeLanguage) {
      //   iecText = '(Please note that there may be an additional six months of Intensive English tuition included at the beginning of your course subject to review by DE International.)';
      // } else if (this.hasTakenEnglishTest === false && this.areAllSubjectsTaughtInEnglish === false && this.isEnlishNativeLanguage === false) {
      //   iecText = '(Please note that based on your current level of English proficiency, there will be an additional six months of Intensive English tuition included at the beginning of your course.)';
      // }
      iecText = '(Please choose the school term when you would like to commence your studies, inclusive of 2 terms of study at an Intensive English Centre (IEC))'
    }
    return iecText;
  }

  changeCheckAdditionalMsg(event): void{
    this.checkAdditionMsg = event.checked;
  }

  showAdditionalMsg(): boolean{
    return this.selectedYearOfEntryCode === 'Year11' && (this.selectedStartTermCode==='Term3' || this.selectedStartTermCode==='Term4');

    //return this.isLastTwoYear() && (this.selectedStartTermCode==='Term3' || this.selectedStartTermCode==='Term4');
  }

  getSchoolStartYearText(): string {
    const startTermYear = this.schoolProgramFormGroup.get('startTermYear').value;

    return startTermYear;
  }

  updateIecStartTermCode(iecStartTermCode: string) {
    this.selectedIecStartTermCode = iecStartTermCode;

    this.schoolProgramFormGroup.patchValue({
      iecStartTermCode: iecStartTermCode
    });

    this.schoolProgramFormGroup.updateValueAndValidity();

    this.updateSchoolStartTermYear();
  }

  onIecStartTermYearChange(iecStartTermYear: any) {

    if (isNaN(iecStartTermYear)) {
      //console.log(`iecStartTermYear,${iecStartTermYear}`);
      this.schoolProgramFormGroup.get('iecStartTermYear').setErrors({ notANumber: true });
      this.schoolProgramFormGroup.updateValueAndValidity();
      return;
    }


    this.schoolProgramFormGroup.patchValue({
      iecStartTermYear
    });

    this.schoolProgramFormGroup.updateValueAndValidity();
    this.updateSchoolStartTermYear();
  }

  updateStartTermCode(startTermCode: string) {
    this.selectedStartTermCode = startTermCode;

    this.schoolProgramFormGroup.patchValue({
      startTermCode: startTermCode
    });

    this.schoolProgramFormGroup.updateValueAndValidity();
  }

  updateYear12InNSW(year12InNSW: boolean){
    this.selectedYear12InNSW = year12InNSW;

    this.schoolProgramFormGroup.patchValue({
      year12InNSW: year12InNSW
    });

    this.schoolProgramFormGroup.updateValueAndValidity();
  }

  updateYear11InNSW(year11InNSW: boolean){
    this.selectedYear11InNSW = year11InNSW;

    this.schoolProgramFormGroup.patchValue({
      year11InNSW: year11InNSW
    });

    this.schoolProgramFormGroup.updateValueAndValidity();
  }

  updateFromTRP(fromTRP: boolean){
    this.selectedFromTRP = fromTRP;

    this.schoolProgramFormGroup.patchValue({
      fromTRP: fromTRP
    });

    this.schoolProgramFormGroup.updateValueAndValidity();
  }

  updateIsSiblingEnrolledInAustralia(isSiblingEnrolledInAustralia: boolean) {
    this.selectedIsSiblingEnrolledInAustralia = isSiblingEnrolledInAustralia;

    this.schoolProgramFormGroup.patchValue({
      isSiblingEnrolledInAustralia: isSiblingEnrolledInAustralia
    });

    if (!isSiblingEnrolledInAustralia) {
      this.schoolProgramFormGroup.patchValue({
        siblingGivenName: '',
        siblingFamilyName: '',
        siblingPreferredName: '',
        siblingDateOfBirth: null,
        siblingSchoolName: '',
        siblingStudentNumber: '',
        siblingComments: '',
      });
    }

    this.schoolProgramFormGroup.updateValueAndValidity();

    // this.configureJquery();
  }

  updateHasASiblingEnrollingAtTheSameTime(hasASiblingEnrollingAtTheSameTime: boolean) {
    this.selectedHasASiblingEnrollingAtTheSameTime = hasASiblingEnrollingAtTheSameTime;

    this.schoolProgramFormGroup.patchValue({
      hasASiblingEnrollingAtTheSameTime: hasASiblingEnrollingAtTheSameTime
    });

    this.schoolProgramFormGroup.updateValueAndValidity();

    // this.configureJquery();
  }


  getDuration(termCode: string): LookupData {
    const duration = this.terms.find(term => term.Code === termCode);

    if (duration) {
      return duration;
    }

    return this.getDefaultOption();
  }

  getCompulsorySubject(subjectCode: string): LookupData {
    const compulsorySubject = this.schoolSubjects.find(schoolSubject => schoolSubject.Code === subjectCode);

    if (compulsorySubject) {
      return compulsorySubject;
    }

    return this.getDefaultOption();

  }

  getDefaultOption(): LookupData {
    return {
      Code: '',
      Description: 'Please select'
    };
  }

  getDefaultSchool(): School {
    return {
      Id: '',
      Name: '',
      GenderType: '',
      HasISP: true,
      HasStudyAbroad: false,
      SchoolSubType: {},
      SchoolLevel: {}
    };
  }


  getSchool(schoolId: string): School {
    const selectedSchool = this.schools.find(school => school.Id == schoolId);

    if (selectedSchool) {
      return selectedSchool;
    }

    return this.getDefaultSchool();
  }

  convertDateToString(dateInString: string): string {
    if (!dateInString) {
      return null;
    }

    const date = new Date(dateInString);
    const dateStr = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : '';
    return dateStr;
  }


  handleYearOfEntryChanges(yearOfEntryCode: string): void {

    this.isIntensiveEnglishCourseAvailable = yearOfEntryCode === 'Year7' ||
      yearOfEntryCode === 'Year8' ||
      yearOfEntryCode === 'Year9' ||
      yearOfEntryCode === 'Year10' ||
      yearOfEntryCode === 'Year11' ||
      yearOfEntryCode === 'Year12';
    this.wishToEnrolIec = false;

  }

  isThisFieldHasErrors(fieldName: string): boolean {
    return this.isFormSubmitted && this.schoolProgramFormGroup.get(fieldName).errors != null;
  }

  isThisFieldHasApiError(fieldName: string): boolean {
    return this.isFormSubmitted
      && this.schoolProgramFormGroup.get(fieldName).errors != null
      && this.schoolProgramFormGroup.get(fieldName).errors.apiValidationError != null;
  }

  setApiValidationError(errors: ErrorKeyValuePair[]): void {
    //console.log(`In setApiValidationError.apiErrorKeyName: ${apiErrorKeyName}, apiErrorMsg:${apiErrorMsg}`);

    //Clear previous error messages before setting new ones
    this.errorKeyFormFieldMapping.forEach((item, index, arr) => {
      item.apiValidationErrorMsg = null;
      const { formFieldName } = item;
      this.schoolProgramFormGroup.get(formFieldName).setErrors(null);
    });

    for (const error of errors) {
      if (error.Key !== 'YearOfEntryRegularCountryError') {
        const errorField = this.errorKeyFormFieldMapping.find(errorKeyFormField => errorKeyFormField.apiErrorKeyName === error.Key);

        if (errorField) {
          const { formFieldName } = errorField;
          this.schoolProgramFormGroup.get(formFieldName).setErrors({ apiValidationError: true });
          errorField.apiValidationErrorMsg = error.Value;
        }
      }
    }
    //console.log('SaveAndContinue - setApiValidationError - this.schoolProgramFormGroup.get(yearOfEntryCode): ', this.schoolProgramFormGroup.get('yearOfEntryCode'));
    //console.log('SaveAndContinue - setApiValidationError - this.schoolProgramFormGroup: ', this.schoolProgramFormGroup );
  }


  /*
  (errorResponse: ErrorResponse) => {
        const { errors } = errorResponse;
        console.log(errorResponse);
        for (const error of errors) {
          this.setApiValidationError(error.Key, error.Value);
        }
        this.visaohscFormGroup.updateValueAndValidity();
        this.configureJquery();
        this.dispatchSectionSaveAction();
        this.initialVisaOHSCDetails = this.getVisaOHSCDetails();
        this.isScrollDone = false;
    });

    setApiValidationError(apiErrorKeyName: string, apiErrorMsg): void {
    const errorField = this.errorKeyFormFieldMapping.find( errorKeyFormField => errorKeyFormField.apiErrorKeyName === apiErrorKeyName);
      if (errorField) {
        const { formFieldName }  = errorField;
        this.visaohscFormGroup.get(formFieldName).setErrors({apiValidationError : true});
        errorField.apiValidationErrorMsg = apiErrorMsg;
      }
    }
  */

  getApiValidationErrorMsg(formFieldName: string): string {
    //console.log('getApiValidationErrorMsg', formFieldName);
    //console.log('this.errorKeyFormFieldMapping', this.errorKeyFormFieldMapping);
    const errorField = this.errorKeyFormFieldMapping.find(errorKeyFormField => errorKeyFormField.formFieldName === formFieldName);
    return errorField.apiValidationErrorMsg ? errorField.apiValidationErrorMsg : '';
  }

  previous() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'english-proficiency']);
  }
  next() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
  }

  getSchoolProgramPlacementDetails(): SchoolProgramPlacementDetails {

    const schoolProgramPlacementDetails = new SchoolProgramPlacementDetails();
    schoolProgramPlacementDetails.SchoolProgramType = this.getStringFieldValue('schoolProgramType');
    schoolProgramPlacementDetails.YearOfEntryCode = this.getStringFieldValue('yearOfEntryCode');
    schoolProgramPlacementDetails.WishToEnrolIec = false;
    schoolProgramPlacementDetails.IecStartTermCode = this.getStringFieldValue('iecStartTermCode');
    schoolProgramPlacementDetails.IecStartTermYear = this.getNumberFieldValue('iecStartTermYear');
    schoolProgramPlacementDetails.IecDurationCode = '2Term';
    schoolProgramPlacementDetails.StartTermCode = this.getStringFieldValue('startTermCode');
    schoolProgramPlacementDetails.StartTermYear = this.getNumberFieldValue('startTermYear');
    schoolProgramPlacementDetails.DurationCode = this.getStringFieldValue('durationCode');

    schoolProgramPlacementDetails.Year12InNSW = this.schoolProgramFormGroup.get('year12InNSW').value;
    schoolProgramPlacementDetails.Year11InNSW = this.schoolProgramFormGroup.get('year11InNSW').value;
    schoolProgramPlacementDetails.FromTRP = this.schoolProgramFormGroup.get('fromTRP').value;

    schoolProgramPlacementDetails.CompulsorySubject1Code = this.getStringFieldValue('compulsorySubject1Code');
    schoolProgramPlacementDetails.CompulsorySubject2Code = this.getStringFieldValue('compulsorySubject2Code');
    schoolProgramPlacementDetails.CompulsorySubject3Code = this.getStringFieldValue('compulsorySubject3Code');
    schoolProgramPlacementDetails.CompulsorySubject4Code = this.getStringFieldValue('compulsorySubject4Code');
    schoolProgramPlacementDetails.CompulsorySubject5Code = this.getStringFieldValue('compulsorySubject5Code');
    schoolProgramPlacementDetails.CompulsorySubject6Code = this.getStringFieldValue('compulsorySubject6Code');
    schoolProgramPlacementDetails.CompulsorySubject7Code = this.getStringFieldValue('compulsorySubject7Code');
    schoolProgramPlacementDetails.PreferredSchool1Id = this.getStringFieldValue('preferredSchool1Id');
    schoolProgramPlacementDetails.PreferredSchool2Id = this.getStringFieldValue('preferredSchool2Id');
    schoolProgramPlacementDetails.PreferredSchool3Id = this.getStringFieldValue('preferredSchool3Id');
    schoolProgramPlacementDetails.HasASiblingEnrollingAtTheSameTime = this.schoolProgramFormGroup.get('hasASiblingEnrollingAtTheSameTime').value;
    schoolProgramPlacementDetails.IsSiblingEnrolledInAustralia = this.schoolProgramFormGroup.get('isSiblingEnrolledInAustralia').value;
    schoolProgramPlacementDetails.SiblingGivenName = this.getStringFieldValue('siblingGivenName');
    schoolProgramPlacementDetails.SiblingFamilyName = this.getStringFieldValue('siblingFamilyName');
    schoolProgramPlacementDetails.SiblingPreferredName = this.getStringFieldValue('siblingPreferredName');
    schoolProgramPlacementDetails.SiblingDateOfBirth = this.getDate('siblingDateOfBirth');
    schoolProgramPlacementDetails.SiblingSchoolName = this.getStringFieldValue('siblingSchoolName');
    schoolProgramPlacementDetails.SiblingStudentNumber = this.getStringFieldValue('siblingStudentNumber');
    schoolProgramPlacementDetails.SiblingComments = this.getStringFieldValue('siblingComments');
    schoolProgramPlacementDetails.AllowAdditionalMessage = this.checkAdditionMsg;
    return schoolProgramPlacementDetails;

  }


  getStringFieldValue(formFieldName: string): string {
    return this.schoolProgramFormGroup.get(formFieldName).value;
  }

  getBooleanFieldValue(formFieldName: string): any {
    return this.schoolProgramFormGroup.get(formFieldName).value;
  }

  getNumberFieldValue(formFieldName: string): number {
    return this.schoolProgramFormGroup.get(formFieldName).value;
  }


  updateFormValuesFromProgramDetails(programDetails: SchoolProgramPlacementDetails): void {

    //console.log("school program details loaded from db is:", programDetails);

    this.isEligibleForStudyAbroad = programDetails.IsEligibleForStudyAbroad;
    this.studentAge = programDetails.AgeInYears;
    this.isStudentFromRegularCountry = programDetails.IsStudentFromRegularCountry;

    this.eligibleYearOfEntries = programDetails.EligibleYearOfEntries;
    if (!this.eligibleYearOfEntries) this.eligibleYearOfEntries = [];

    //console.log(`Student Age:${this.studentAge}`);

    //MN-512 need to filter out based on gender (already knew) and then isp or studyabroad
    this.filterSchoolsFromGender(programDetails.Gender);

    let preferredSchool1 = this.schools.find(school => school.Id == programDetails.PreferredSchool1Id);
    let preferredSchool2 = this.schools.find(school => school.Id == programDetails.PreferredSchool2Id);
    let preferredSchool3 = this.schools.find(school => school.Id == programDetails.PreferredSchool3Id);

    this.schoolProgramFormGroup.patchValue({
      schoolProgramType: programDetails.SchoolProgramType,
      yearOfEntryCode: programDetails.YearOfEntryCode,
      wishToEnrolIec: programDetails.WishToEnrolIec && false,
      iecStartTermCode: programDetails.IecStartTermCode,
      iecStartTermYear: programDetails.IecStartTermYear == null ? '' : programDetails.IecStartTermYear,
      iecDurationCode: programDetails.IecDurationCode,
      startTermCode: programDetails.StartTermCode,
      startTermYear: programDetails.StartTermYear == null ? '' : programDetails.StartTermYear,
      durationCode: programDetails.DurationCode == null ? '' : programDetails.DurationCode,
      compulsorySubject1Code: 'English', // programDetails.CompulsorySubject1Code,
      year12InNSW: programDetails.Year12InNSW,
      year11InNSW: programDetails.Year11InNSW,
      fromTRP:programDetails.FromTRP,
      compulsorySubject2Code: programDetails.CompulsorySubject2Code ? programDetails.CompulsorySubject2Code : '',
      compulsorySubject3Code: programDetails.CompulsorySubject3Code ? programDetails.CompulsorySubject3Code : '',
      compulsorySubject4Code: programDetails.CompulsorySubject4Code ? programDetails.CompulsorySubject4Code : '',
      compulsorySubject5Code: programDetails.CompulsorySubject5Code ? programDetails.CompulsorySubject5Code : '',
      compulsorySubject6Code: programDetails.CompulsorySubject6Code ? programDetails.CompulsorySubject6Code : '',
      compulsorySubject7Code: programDetails.CompulsorySubject7Code ? programDetails.CompulsorySubject7Code : '',
      preferredSchool1Id: programDetails.PreferredSchool1Id,
      selectedPreferredSchool1Name: preferredSchool1 == null ? '' : preferredSchool1.Name,
      preferredSchool2Id: programDetails.PreferredSchool2Id,
      selectedPreferredSchool2Name: preferredSchool2 == null ? '' : preferredSchool2.Name,
      preferredSchool3Id: programDetails.PreferredSchool3Id,
      hasASiblingEnrollingAtTheSameTime: programDetails.HasASiblingEnrollingAtTheSameTime,
      selectedPreferredSchool3Name: preferredSchool3 == null ? '' : preferredSchool3.Name,
      isSiblingEnrolledInAustralia: programDetails.IsSiblingEnrolledInAustralia,
      siblingGivenName: programDetails.SiblingGivenName,
      siblingFamilyName: programDetails.SiblingFamilyName,
      siblingPreferredName: programDetails.SiblingPreferredName,
      siblingDateOfBirth: programDetails.SiblingDateOfBirth ? new Date(programDetails.SiblingDateOfBirth) : null,
      siblingSchoolName: programDetails.SiblingSchoolName,
      siblingStudentNumber: programDetails.SiblingStudentNumber,
      siblingComments: programDetails.SiblingComments
    });

    this.selectedYearOfEntryCode = programDetails.YearOfEntryCode;
    this.selectedHasASiblingEnrollingAtTheSameTime = programDetails.HasASiblingEnrollingAtTheSameTime;
    this.selectedIsSiblingEnrolledInAustralia = programDetails.IsSiblingEnrolledInAustralia;
    this.selectedPreferredSchool1Name = this.getSchool(programDetails.PreferredSchool1Id).Name.trim();
    this.selectedPreferredSchool2Name = this.getSchool(programDetails.PreferredSchool2Id).Name.trim();
    this.selectedPreferredSchool3Name = this.getSchool(programDetails.PreferredSchool3Id).Name.trim();

    this.selectedYear11InNSW = programDetails.Year11InNSW;
    this.selectedYear12InNSW = programDetails.Year12InNSW;
    this.selectedFromTRP = programDetails.FromTRP;

    this.isIntensiveEnglishCourseAvailable = programDetails.YearOfEntryCode === 'Year7' ||
      programDetails.YearOfEntryCode === 'Year8' ||
      programDetails.YearOfEntryCode === 'Year9' ||
      programDetails.YearOfEntryCode === 'Year10' ||
      programDetails.YearOfEntryCode === 'Year11' ||
      programDetails.YearOfEntryCode === 'Year12';

    this.selectedWishToEnrolIec = programDetails.WishToEnrolIec && false // We don't need this question any more;
    this.selectedIecStartTermCode = programDetails.IecStartTermCode;
    this.selectedStartTermCode = programDetails.StartTermCode;
    this.selectedProgram = programDetails.SchoolProgramType;

    //have to do this explicitly
    this.selectedPreferredSchool1Name = preferredSchool1 == null ? '' : preferredSchool1.Name;
    this.selectedPreferredSchool2Name = preferredSchool2 == null ? '' : preferredSchool2.Name;
    this.selectedPreferredSchool3Name = preferredSchool3 == null ? '' : preferredSchool3.Name;


    //capture the 'original school list' snapshot
    //this.originalSchoolList = this.schools;

    //in case user saved before and go back to this page
    //this.updateSelectableSchoolList();
  }

  filterSchoolsFromGender(studentGender: string) {
    if (studentGender === 'M') {
      this.schools = this.schools.filter(s => !s.GenderType || s.GenderType.toLowerCase() !== "girls");
    }
    else if (studentGender === 'F') {
      this.schools = this.schools.filter(s => !s.GenderType || s.GenderType.toLowerCase() !== "boys");
    }

    // console.log("--- school list after filter by gender is:", this.schools);
  }


  getDate(fieldName: string): string {

    // const dateObject = new Date($(`#${fieldName}`).datepicker('getDate'));
    // const dateObject = this.schoolProgramFormGroup.get(fieldName).value;
    // const dateTimeObject = DateTime.fromJSDate(dateObject);

    // if (!dateTimeObject.isValid) {
    //   return null;
    // }

    // const initialDate = new Date(1970, 0, 1);

    // if (dateObject.getDate() === initialDate.getDate() &&
    //   dateObject.getMonth() === initialDate.getMonth() &&
    //   dateObject.getFullYear() === initialDate.getFullYear()) {
    //   //console.log('no date to db');
    //   return null;
    // }
    // // const dateObject = this.schoolProgramFormGroup.get(fieldName).value;
    // const userTimezoneOffset = dateObject.getTimezoneOffset() * 60000;
    // const date = new Date(dateObject.getTime() - userTimezoneOffset);
    // //console.log('date to db', date.toISOString());
    // return date.toISOString();

    return this.utilityService.getDateStrWithoutTimeZone(this.schoolProgramFormGroup.get(fieldName).value);
  }



  saveAndContinue(): void {
    this.updatePreferredSchoolByName(this.selectedPreferredSchool1Name, 1);
    this.updatePreferredSchoolByName(this.selectedPreferredSchool2Name, 2);
    this.updatePreferredSchoolByName(this.selectedPreferredSchool3Name, 3);
    const programDetails = this.getSchoolProgramPlacementDetails();
    this.isFormSubmitted = true;
    if(this.showAdditionalMsg() && !this.checkAdditionMsg){
      return;
    }
    if(this.showYear12ErrorMsg()){
      return;
    }
    this.applicationService.updateSchoolProgramAndPlacementDetails(this.applicationId, programDetails)
      .subscribe((response: SingleResultApiResponse) => {
        this.dispatchSectionSaveAction();
        this.isSaveSuccessful = true;
        if (this.isSchoolProgramChanged()) {
          //console.log('program changed.. going to fire an program change action');
          this.dispatchProgramChangeAction();
        }

        if (response.Result) {
          this.showChangeImpactModal = response.Result.IsSchoolProgramStatusChanged || response.Result.IsYearOfEntryStatusChanged;
        }
        if (this.showChangeImpactModal === false) {
          this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
        } else {
          setTimeout(() => {
            this.resolve.nativeElement.focus();
          }, 100);
        }
      }, (errorResponse: ErrorResponse) => {
        const { errors } = errorResponse;

        //console.log('errors: ', errors);



        this.setApiValidationError(errors);

        this.schoolProgramFormGroup.updateValueAndValidity();

        //console.log('SaveAndContinue 2- this.schoolProgramFormGroup.get(yearOfEntryCode): ', this.schoolProgramFormGroup.get('yearOfEntryCode'));

        // console.log('this.schoolProgramFormGroup.get(yearOfEntryCode).errors');
        // console.log(this.schoolProgramFormGroup.get('yearOfEntryCode').errors);
        // console.log(this.schoolProgramFormGroup);

        this.dispatchSectionSaveAction();
        if (this.isSchoolProgramChanged()) {
          //console.log('program changed.. going to fire an program change action');
          this.dispatchProgramChangeAction();
        }
        this.initialSchoolProgramPlacementDetails = this.getSchoolProgramPlacementDetails();
        this.isScrollDone = false;
        this.formService.scrollToFirstErrorField();
      });

  }

  canDeactivate(): Observable<boolean> | boolean {

    if (this.isSaveSuccessful) {
      return true;
    }

    if (!this.isSchoolProgramPlacementDetailsSame()) {
      this.modalService.showModal();
      return this.modalService.stayOnThePage;
    } else {
      this.modalService.hideModal();
      return true;
    }
  }


  isSchoolProgramPlacementDetailsSame(): boolean {

    const currentSchoolProgramPlacementDetails = this.getSchoolProgramPlacementDetails();
    const initialSchoolProgramPlacementDetails = this.initialSchoolProgramPlacementDetails;

    const isSchoolProgramPlacementDetailsSame =
      compareSchoolProgramPlacementDetails(initialSchoolProgramPlacementDetails, currentSchoolProgramPlacementDetails);

    return isSchoolProgramPlacementDetailsSame;
  }

  isSchoolProgramChanged(): boolean {

    const currentSchoolProgramPlacementDetails = this.getSchoolProgramPlacementDetails();
    const initialSchoolProgramPlacementDetails = this.initialSchoolProgramPlacementDetails;
    console.info("currentSchoolProgramPlacementDetails", currentSchoolProgramPlacementDetails);
    console.info("initialSchoolProgramPlacementDetails", initialSchoolProgramPlacementDetails);
    return currentSchoolProgramPlacementDetails.SchoolProgramType !== initialSchoolProgramPlacementDetails.SchoolProgramType;
  }

  ngAfterContentChecked(): void {
    if (!this.isScrollDone) {
      this.isScrollDone = this.formService.scrollToFirstErrorField();
    }
  }

  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }

  dispatchProgramChangeAction() {
    this.store.dispatch({
      type: Action_ApplicationProgramChanged
    });
  }

  displayChangeImpactModal(): boolean {
    return this.showChangeImpactModal;
  }

  closeChangeImpactModal() {
    this.showChangeImpactModal = false;
    this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  //accessibility -- link error msg to form field
  errorDoubleErrorAccessibility(formControlName: string, requireErrorId: string, apiErrorId: string): string {
    if (this.isFormSubmitted &&
      this.schoolProgramFormGroup.get(formControlName).errors &&
      this.schoolProgramFormGroup.get(formControlName).errors.required) {
      return requireErrorId;
    } else if (this.isFormSubmitted &&
      this.schoolProgramFormGroup.get(formControlName).errors &&
      this.schoolProgramFormGroup.get(formControlName).errors.apiValidationError) {
      return apiErrorId;
    } else {
      return "";
    }
  }
}
